/* istanbul ignore file */
import React from 'react';
import SingleSkillBasedQueueBreadcrumbs from 'domain/gpo/skillBasedQueue/shared/SingleSkillBasedQueueBreadcrumbs';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const UpdateSkillBasedQueueBreadcrumbs = () => {
  return (
    <SingleSkillBasedQueueBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleSkillBasedQueueBreadcrumbs>
  );
};

export default UpdateSkillBasedQueueBreadcrumbs;
